<template>
  <div class="c-input-text">
    <label class="c-input-text__label" :for="'input' + type">{{ title }}</label>
    <span class="c-input-text__wrapper">
      <input
        :type="inputType"
        :id="'input' + type"
        :required="isRequired ? true : false"
        :pattern="inputPattern && inputPattern !== '' ? inputPattern : null"
        :maxlength="inputSize && inputSize > 0 ? inputSize : null"
        :title="inputTitle && inputTitle !== '' ? inputTitle : null"
        :class="{ 'c-input-text__field': true, invalid: invalid }"
        v-on:keydown.enter.prevent="true"
        v-model="text"
        v-on:input="oninput"
        @change="change"
      />
    </span>
    <span class="c-input-text__note">{{ note }}</span>
    <span class="validate_error" v-show="validateShow && text == '' || invalid" >{{validateText || 'Skal udfyldes'}}</span>
  </div>
</template>
<script>
export default {
  name: 'InputText',
  data() {
    return {
      title: this.dataTitle ? this.dataTitle : '',
      type: this.dataType ? this.dataType : '',
      isRequired: this.dataIsRequired ? this.dataIsRequired : false,
      inputType: this.dataInputType ? this.dataInputType : '',
      inputPattern: this.dataInputPattern ? this.dataInputPattern : '',
      inputSize: this.dataInputSize ? this.dataInputSize : 255,
      inputTitle: this.dataInputTitle ? this.dataInputTitle : '',
      text: this.dataText ? this.dataText : '',
      invalid: false,
      note: this.dataNote ? this.dataNote : ''
    };
  },
  props: {
    dataTitle: String,
    dataType: String,
    dataIsRequired: Boolean,
    dataInputType: String,
    dataInputPattern: String,
    dataInputSize: Number,
    dataInputTitle: String,
    dataText: [String, Number],
    dataNote: String,
    validateShow: Boolean,
    validateText: String,
    restrictedToNumbers: Boolean,
    restrictedToLength: Number
  },
  methods: {
    oninput() {
      if (this.restrictedToNumbers) 
          this.text = this.text.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
      if (this.restrictedToLength)
          this.text = this.text.substring(0, this.restrictedToLength);
      
    },
    change() {
      if (this.inputPattern != '') {
        let re = new RegExp(this.inputPattern);
        if (re.test(this.text)) {
          this.$emit('childToParent', this.text);
          this.invalid = false;
        } else {
          this.$emit('childToParent', '');
          this.invalid = true;
        }
      } else {
        this.invalid = false;
        this.$emit('childToParent', this.text);
      }
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
@import './input-text';

.validate_error{
  color: #e6462c;
  font-size: 0.7rem;
  min-height: 7px;
  display: inline-block;
  text-align: left;
}
</style>
